import { useRef } from 'react';

/**
 * Hook that returns the previous value of the passed value.
 * Returns null if there is no previous value available.
 */
export function useFromPreviousValue<T>(currentValue: T): T | null {
  const currentRef = useRef<T>(currentValue);
  const previousRef = useRef<T | null>(null);

  if (currentValue !== currentRef.current) {
    previousRef.current = currentRef.current;
    currentRef.current = currentValue;
  }

  return previousRef.current;
}
